import { render } from "./registration.vue?vue&type=template&id=fa35bbf6"
import script from "./registration.vue?vue&type=script&lang=js"
export * from "./registration.vue?vue&type=script&lang=js"

import "./registration.vue?vue&type=style&index=0&id=fa35bbf6&lang=scss"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__